export default [
	'New',
	'Active',
	'Read',
]


// WEBPACK FOOTER //
// ./src/lib/enums/notificationStatus.js